// RequireAuth.js

import React from 'react'
import { connect } from 'react-redux'
import { logoutUnauthorizedUser } from '../../sagas/logout'
import { selectCurrentUser } from '../../stores/currentUser'
import { goToLogin, goToOldLogin } from '../../stores/routing'
import { isAuthenticated } from '../../helpers'
import { isToolUser } from '../../stores/usersStore'

class RequireAuth extends React.Component {
  componentWillMount() {
    const { user, logoutUnauthorizedUser } = this.props

    if (!user || !isAuthenticated()) {
      // If there is no user, call the logoutUnauthorizedUser action
      logoutUnauthorizedUser()

      // Redirect to the login page
      console.log('RequireAuth, redirecting to login')
      isToolUser(user) ? goToLogin() : goToOldLogin()
    }
  }

  render() {
    const { user, children } = this.props

    // Render the children only if there is a user
    return user ? children : null
  }
}

const mapStateToProps = state => ({
  user: selectCurrentUser(state),
})

export default connect(
  mapStateToProps,
  { logoutUnauthorizedUser }
)(RequireAuth)



// WEBPACK FOOTER //
// ./src/components/RequireAuth/RequireAuth.js